const ANALYTICS_VIEWER_ID_STORAGE_KEY = "vdopage_analytics_viewer_id_v1";

function createUuid() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }

  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (char) => {
    const random = Math.floor(Math.random() * 16);
    const value = char === "x" ? random : (random & 0x3) | 0x8;
    return value.toString(16);
  });
}

export function createAnalyticsSessionId() {
  return createUuid();
}

export function createOrGetAnalyticsViewerId() {
  try {
    const existing = window.localStorage.getItem(ANALYTICS_VIEWER_ID_STORAGE_KEY);
    if (existing) return existing;

    const next = createUuid();
    window.localStorage.setItem(ANALYTICS_VIEWER_ID_STORAGE_KEY, next);
    return next;
  } catch (_error) {
    return createUuid();
  }
}

export { ANALYTICS_VIEWER_ID_STORAGE_KEY };
